import { useState, useEffect, useRef } from 'react';
import { X } from 'lucide-react';

const CONTACT_FORM_URL = 'https://forms.gle/iY5bD4UquLSFS8639';

const ContactModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      closeButtonRef.current?.focus();
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleOpenForm = () => {
    window.open(CONTACT_FORM_URL, '_blank');
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content contact-modal" ref={modalRef} role="dialog" aria-modal="true" aria-labelledby="contact-title">
        <div className="modal-header">
          <h2 id="contact-title" className="modal-title">تواصل معنا</h2>
          <button 
            ref={closeButtonRef}
            className="modal-close" 
            onClick={onClose}
            aria-label="إغلاق"
          >
            <X size={24} />
          </button>
        </div>
        
        <div className="modal-body contact-modal-body">
          <p className="contact-intro">
            هل لديك استفسارات أو اقتراحات؟ يسعدنا تواصلك معنا.
          </p>
          
          <p className="contact-note">
            التواصل يحتاج اتصال إنترنت.
          </p>
          
          <button 
            className="btn-primary btn-contact-form"
            onClick={handleOpenForm}
          >
            فتح نموذج التواصل
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContactModal;
